import { render, staticRenderFns } from "./index.vue?vue&type=template&id=126d66ab&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=126d66ab&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126d66ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('126d66ab')) {
      api.createRecord('126d66ab', component.options)
    } else {
      api.reload('126d66ab', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=126d66ab&scoped=true", function () {
      api.rerender('126d66ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/IotMap/index.vue"
export default component.exports